import getCalculatedDelay from "./getCalculatedDelay";
import getPartnerPromotionCode from "./getPartnerPromotionCode";
import getTargetingCookies from "./getTargetingCookies";
import getTrustPilotConfiguration from "./getTrustPilotConfiguration";
import isBrandingPartner from "./isBrandingPartner";

export {
  getCalculatedDelay,
  getPartnerPromotionCode,
  getTargetingCookies,
  getTrustPilotConfiguration,
  isBrandingPartner,
};
